<template>
    <div class="select" :class="inputClass" v-click-outside="clickOutside">
        <div class="input" :class="{active:dropdown}" @click="dropdown = !dropdown">
            <input :value="value" readonly :placeholder="title">
        </div>
        <ul v-if="options && dropdown" class="dropdown-options">
            <li v-for="option in options">
                <label class="checkbox dark">
                    <input type="checkbox"
                           @click="check(option)"
                           :checked="isChecked(option)">
                    <span class="checkbox__text">
                        {{ option.value }}
                    </span>
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
import fn from "../../js/fn"
import ClickOutside from "./directives/ClickOutside";
export default {
    name: "RadiogroupDropdown",
    directives: {
        'click-outside': ClickOutside
    },
    props: {
        title: {
            type: String,
            default: null
        },
        options: {
            type: Array,
            default: null,
        },
        inputClass: null
    },
    data() {
        return {
            selected: [],
            dropdown: false,
        }
    },
    computed: {
        value() {
            let output = []
            for(let i in this.options) {
                if (this.selected.indexOf(this.options[i].id) !== -1) {
                    output.push(this.options[i].value)
                }
            }
            if (!output.length) {
                return null
            }

            let added = ''

            if (output.length > 1) {
                let added_count = output.length - 1
                let unit = fn.incline(added_count, ['пункт', 'пункта', 'пунктов'])
                added = ` (+ ${ added_count } ${unit})`
            }

            return output[0] + added
        }
    },
    watch: {
        selected(selected)
        {
            this.$emit('change', selected)
        }
    },
    methods: {
        isChecked(option)
        {
            return !!this.selected.find(item => {
                return item === option.id
            })
        },
        check(option)
        {
            for (let i in this.options) {
                if (this.options[i] === option) {
                    let option_index = this.selected.indexOf(option.id)
                    if (option_index === -1) {
                        this.selected.push(option.id)
                    } else {
                        this.selected.splice(option_index, 1)
                    }
                }
            }
        },
        clickOutside()
        {
            if (this.dropdown) {
                this.dropdown = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.dropdown-options {
    animation: dropdown-animation;
    animation-duration: 100ms;
    overflow: hidden;
}
@keyframes dropdown-animation {
    from {
        height: 0;
        line-height: 0;
    }
}
</style>
